import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import AnimatedOrderRoute from "@app/components/routing/AnimatedOrderRoute/AnimatedOrderRoute"

export default function OrderContentBody({ children, className, style, routeStyle, route }) {
	return (
		<AnimatedOrderRoute style={{ overflowY: "auto", ...(routeStyle || {}), height: routeStyle ? routeStyle.height : "" }} route={route} className="flex-1">
			<ContentBody className={className + " pt-2"} style={{ ...style }}>
				{children}
			</ContentBody>
		</AnimatedOrderRoute>
	)
}
